import type { PracticeScoringSnapshot } from "./noteScoring";

/** Porcentaje 0–100 para modales e informes de tarea. */
export function practiceAccuracyPercent(snapshot: PracticeScoringSnapshot): number {
  if (snapshot.total > 0) {
    return Math.round(snapshot.accuracy * 100);
  }
  if (snapshot.eventTotal > 0) {
    const weighted =
      (snapshot.eventHit + snapshot.eventPartial * 0.5) / snapshot.eventTotal;
    return Math.round(weighted * 100);
  }
  return 0;
}

export function practiceScoreSummaryLines(snapshot: PracticeScoringSnapshot): {
  headline: string;
  detail: string;
} {
  const pct = practiceAccuracyPercent(snapshot);
  if (snapshot.total > 0) {
    const credited = snapshot.hit + snapshot.late;
    return {
      headline: `${pct}%`,
      detail: `Lograste ${credited} de ${snapshot.total} notas${
        snapshot.late > 0 ? ` (${snapshot.late} un poco tarde)` : ""
      }. Fallaron ${snapshot.miss}.`,
    };
  }
  if (snapshot.eventTotal > 0) {
    return {
      headline: `${pct}%`,
      detail: `${snapshot.eventHit} de ${snapshot.eventTotal} acordes/eventos correctos${
        snapshot.eventPartial > 0 ? `, ${snapshot.eventPartial} parciales` : ""
      }${snapshot.eventMiss > 0 ? `, ${snapshot.eventMiss} fallados` : ""}.`,
    };
  }
  return {
    headline: "—",
    detail: "No hubo calificación por micrófono en esta pasada. Prueba con entrada de línea o una pieza menos densa.",
  };
}
